document.addEventListener('DOMContentLoaded', function() {
  const loadMoreButton = document.getElementById('load-more-button');
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      const hiddenArticles = document.querySelectorAll('.article-item.hidden');
      let count = 0;
      
      hiddenArticles.forEach(function(article) {
        if (count < 6) {
          article.classList.remove('hidden');
          count++;
        }
      });
      
      // Hide the load more button if no more hidden articles
      if (document.querySelectorAll('.article-item.hidden').length === 0) {
        loadMoreButton.style.display = 'none';
      }
    });
  }
});